module.exports = __webpack_public_path__ + "static/img/whatsapp-logo.aede9fa5.svg";